var React = require('react');

function Copy (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.98581 7H19.2524C20.2834 7 21.1191 7.69645 21.1191 8.55556V19.4444C21.1191 20.3036 20.2834 21 19.2524 21H8.98581C7.95488 21 7.11914 20.3036 7.11914 19.4444V8.55556C7.11914 7.69645 7.95488 7 8.98581 7ZM8.11914 20H20.1191V8H8.11914V20Z","fill":"#00412F","key":0}),React.createElement("path",{"d":"M16.1191 4H6.11914C5.01457 4 4.11914 4.89543 4.11914 6V16.1406H5.11914V5H16.1191V4Z","fill":"#00412F","key":1})]);
}

Copy.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = Copy;

Copy.default = Copy;
